module.exports = __webpack_public_path__ + "static/media/logo.153c3e68.png";